const objFunc = () => {
  return {
    /**
     * This value is a custom attribute thats comes from Cognito Custom Properties
     * This property is defined in AWS Cognito as "custom:non_customer_refer"
     * This value is further defined client side by "NcrType" from 'constants.js'
     */
    ncrCognitoAttribute: undefined,

    /**
     * Referral info associated with the customer.
     */
    pendingCashOut: undefined,
    peopleSignedUp: 0,
    referCodesScanned: 0,
    balanceHistory: [],
    currentBalance: 0,
    referralUrl: '',
    shortCode: '',

    cardId: '',
    cardName: '',
    cardNumber: '',
    cardType: '',
    disbursementAmount: 0,
    amountPerShare: 50
  }
}

export default objFunc()

export const defaultObj = objFunc()
